import React, { useEffect, useState } from 'react'
import { ButtonCmp, TextAreaCmp } from '../../Components'
import styles from './Detail.module.css'
import { BASE_URL } from '../../Utils/response'
import { getUserToken } from '../../Utils/LoginAuth'
import { Box, Card, Typography, Link } from '@mui/material'
import useAlert from '../../Hooks/useAlert/useAlert'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { useParams } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import { useForm, Controller, useFieldArray } from 'react-hook-form'
import { DropDownCmp } from '../../Components'
import { FaRegFilePdf, FaFileWord, FaFileImage, FaFile } from 'react-icons/fa'
import { IoMdAttach } from 'react-icons/io'
import Button from '@mui/material/Button'
import BoxCmp from './BoxCmp'
import { validation } from '../../Config'
import { yupResolver } from '@hookform/resolvers/yup'

const Detail = () => {
    const { setAlert } = useAlert()
    const { orderId } = useParams()
    const location = useLocation()
    const order = location.state

    const [errors, setErrors] = useState([])
    const [submitting, setSubmitting] = useState(false)
    // Convert strings to Date objects
    let date1 = new Date(order?.updated_at)
    let date2 = new Date()

    date2.setDate(date2.getDate() + 8)

    // Calculate the difference in time (milliseconds)
    let timeDifference = date2 - date1

    // Convert time difference from milliseconds to days
    let dayDifference = (timeDifference / (1000 * 60 * 60 * 24)).toLocaleString(
        'en-US',
        { maximumFractionDigits: 0 }
    )

    const getHeader = () => {
        return {
            Authorization: 'Bearer ' + getUserToken(),
            'content-type': 'multipart/form-data',
        }
    }

    const handleAccept = () => {
        const formData = new FormData()
        formData.append('status', 'Accepted')

        axios
            .post(
                `${BASE_URL}/user-verifications-orders/${orderId}/verifications-orders-status`,
                formData,
                {
                    headers: getHeader(),
                }
            )
            .then((response) => {
                setAlert(response.data.message || 'Order Accepted', 'success')
                navigate(`/buildinsurance/orders/general`)
            })
            .catch((error) => {
                console.log(error.response.data.message)
                setAlert(
                    error.response.data.message || 'An error occurred',
                    'error'
                )
            })
    }

    const handleReject = () => {
        const formData = new FormData()
        formData.append('status', 'Declined')

        axios
            .post(
                `${BASE_URL}/user-verifications-orders/${orderId}/verifications-orders-status`,
                formData,
                {
                    headers: getHeader(),
                }
            )
            .then((response) => {
                setAlert(response.data.message || 'Order Accepted', 'success')
                navigate(`/buildinsurance/orders/general`)
            })
            .catch((error) => {
                console.log(error.response.data.message)
                setAlert(
                    error.response.data.message || 'An error occurred',
                    'error'
                )
            })
    }

    const navigate = useNavigate()

    // const formValidation = validation.productValidation
    const { control, handleSubmit, setValue, watch } = useForm({
        mode: 'onChange',
        // resolver: yupResolver(validation.certificatesValidation),
    })

    const {
        fields: certificateFields,
        append: certificateAppend,
        replace: certificateReplace,
    } = useFieldArray({
        control,
        name: 'certificates',
    })

    useEffect(() => {
        certificateReplace([])
        order?.requested_for_user?.certificates
            .filter((item) => item?.status !== 'Verified')
            .forEach((item) => {
                certificateAppend({
                    certificate_id: item.id,
                    certificate_expiry: item.expiry,
                    certificate_comment: item.comment,
                    certificate_status: item.status,
                    certificate_attachment: null,
                    // certificate_attachment: item.ImgURL + item.document,
                    certificate_attachment_url: item.ImgURL + item.document,
                    certificate_attachment_name: '',
                })
            })
        // order.requested_for_user.certificates
        // .filter((item) => item.status !== 'Verified')
        // .forEach((item) => {
        //     certificateAppend({
        //         certificate_id: item.id,
        //         certificate_expiry: item.expiry,
        //         certificate_comment: item.comment,
        //         certificate_status: item.status,
        //         certificate_attachment: item.ImgURL + item.document,
        //         certificate_attachment_name: '',
        //     })
        // })
    }, [])

    const onSubmit = (data) => {
        // const allVerified = data.certificates.every(
        //     (c) => c.certificate_status === 'Verified'
        // )
        // if (!allVerified) {
        //     setAlert(
        //         'All certificate statuses must be "Verified" before submission.',
        //         'error'
        //     )
        //     return
        // }
        setSubmitting(true)
        const formData = new FormData()
        formData.append(`status`, 'Completed')
        data.certificates.forEach((x, i) => {
            formData.append(`certificates[${i}][id]`, x.certificate_id)
            formData.append(
                `certificates[${i}][certificate_status]`,
                x.certificate_status
            )
            formData.append(
                `certificates[${i}][certificate_expiry]`,
                x.certificate_expiry
            )
            formData.append(
                `certificates[${i}][certificate_comment]`,
                x.certificate_comment || ''
            )
            formData.append(
                `certificates[${i}][certificate_attachment]`,
                x.certificate_attachment || ''
            )
        })

        axios
            .post(
                `${BASE_URL}/user-verifications-orders/${orderId}/change-verifications-orders-status`,
                formData,
                {
                    headers: getHeader(),
                }
            )
            .then((response) => {
                setAlert(response.data.message || 'Order Updated', 'success')
                navigate(`/buildinsurance/orders/Accepted`)
            })
            .catch((error) => {
                console.log(error.response.data.message)
                setAlert(
                    error.response.data.message || 'An error occurred',
                    'error'
                )
            })
            .finally(() => {
                setSubmitting(false)
            })
    }

    // const onSubmit = (data) => {
    //     const allVerified = data.certificates.every(
    //         (c) => c.certificate_status === 'Verified'
    //     )
    //     if (!allVerified) {
    //         setAlert(
    //             'All certificate statuses must be "Verified" before submission.',
    //             'error'
    //         )
    //         return
    //     }
    //     setSubmitting(true)
    //     const formData = new FormData()
    //     formData.append('status', 'Completed')

    //     data.certificates.forEach((x, i) => {
    //         formData.append(`certificates[${i}][id]`, x.certificate_id)
    //         formData.append(
    //             `certificates[${i}][certificate_status]`,
    //             x.certificate_status
    //         )
    //         formData.append(
    //             `certificates[${i}][certificate_expiry]`,
    //             x.certificate_expiry
    //         )
    //         formData.append(
    //             `certificates[${i}][certificate_comment]`,
    //             x.certificate_comment
    //         )
    //         x.certificate_attachment.forEach((file, fileIndex) => {
    //             formData.append(
    //                 `certificates[${i}][certificate_attachment][${fileIndex}]`,
    //                 file
    //             )
    //         })
    //     })

    //     axios
    //         .post(
    //             `${BASE_URL}/user-verifications-orders/${orderId}/change-verifications-orders-status`,
    //             formData,
    //             { headers: getHeader() }
    //         )
    //         .then((response) => {
    //             setAlert(response.data.message || 'Order Updated', 'success')
    //             navigate(`/buildinsurance/orders/Accepted`)
    //         })
    //         .catch((error) => {
    //             console.log(error.response.data.message)
    //             setAlert(
    //                 error.response.data.message || 'An error occurred',
    //                 'error'
    //             )
    //         })
    //         .finally(() => {
    //             setSubmitting(false)
    //         })
    // }



    const getFileIcon = (fileExt, status) => {
        let FileIcon
        switch (fileExt) {
            case 'pdf':
                FileIcon = (
                    <FaRegFilePdf
                        style={{
                            fontSize: '16px',
                            color: status == 'Completed' ? 'white' : '#e63946',
                        }}
                    />
                )
                break
            case 'doc':
            case 'docx':
                FileIcon = (
                    <FaFileWord
                        style={{
                            fontSize: '16px',
                            color: status == 'Completed' ? 'white' : '#1e40af',
                        }}
                    />
                )
                break
            case 'png':
            case 'jpg':
            case 'jpeg':
                FileIcon = (
                    <FaFileImage
                        style={{
                            fontSize: '16px',
                            color: status == 'Completed' ? 'white' : '#10b981',
                        }}
                    />
                )
                break
            default:
                FileIcon = (
                    <FaFile
                        style={{
                            fontSize: '16px',
                            color: status == 'Completed' ? 'white' : '#64748b',
                        }}
                    />
                )
        }
        return FileIcon
    }

    return (
        <>
            <Box
                sx={{ backgroundColor: 'rgb(241 245 249)', paddingTop: '2rem' }}
            >
                {/* <Box
                    style={{
                        display: 'flex',
                        justifyContent: 'space-around',
                        alignItems: 'center',
                        // gap: 2,
                    }}
                >
                    <BoxCmp title={'General Insurance'} price={'298'} />
                    <BoxCmp title={'Construction Insurance'} price={'878'} />
                    <BoxCmp title={''} price={'8'} />
                    <BoxCmp title={''} />
                </Box> */}

                <Box
                    className="!mr-8 flex flex-col items-end gap-3"
                    sx={
                        {
                            // marginRight: '2rem',
                            // display: 'flex',
                            // justifyContent: 'end',
                            // gap: 2,
                        }
                    }
                >
                    {order?.status === 'Pending' && (
                        <Box className="flex items-center gap-3">
                            <ButtonCmp
                                title={'Reject'}
                                btnColor={'error'}
                                onClick={handleReject}
                            ></ButtonCmp>
                            <ButtonCmp
                                onClick={handleAccept}
                                title={'Accept'}
                                btnColor={'success'}
                            ></ButtonCmp>
                        </Box>
                    )}
                    {order?.status === 'Accepted' && (
                        <div>
                            {dayDifference <= 800 && (
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 2,
                                    }}
                                >
                                    <p>
                                        Time left to Submit : {dayDifference}{' '}
                                        days
                                    </p>
                                </Box>
                            )}
                            {dayDifference > 800 && (
                                <Box sx={{}}>Verification Time Expired</Box>
                            )}
                        </div>
                    )}
                </Box>

                <Card
                    sx={{
                        minWidth: 275,
                        margin: '20px',
                        padding: '20px',
                        borderRadius: '10px',
                    }}
                >
                    <div className={styles.profile_information_heading}>
                        <Typography
                            noWrap
                            variant="h5"
                            sx={{ color: 'var(--black)', fontWeight: 'bold' }}
                        >
                            General Details
                        </Typography>
                    </div>

                    <div
                        className={styles.detailsBoxes}
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'flex-start',
                        }}
                    >
                        <div style={{ minWidth: '200px', margin: '0 10px' }}>
                            <p className="font-bold">Company Name</p>
                            <p>
                                {order?.requested_for_user.company_name
                                    ? order?.requested_for_user?.company_name
                                    : 'N/A'}
                            </p>
                        </div>
                        <div style={{ minWidth: '200px', margin: '0 10px' }}>
                            <p className="font-bold">Insurance Category</p>
                            <p>
                                {order?.requested_for_user.company_name
                                    ? order?.requested_from_user?.company_name
                                    : 'N/A'}
                            </p>
                        </div>
                        <div style={{ minWidth: '200px', margin: '0 10px' }}>
                            <p className="font-bold">City, State</p>
                            <p>
                                {order?.requested_for_user.company_name
                                    ? `${order?.requested_for_user?.city?.name}, ${order?.requested_for_user?.state?.name}, ${order?.requested_for_user?.zip}`
                                    : 'N/A'}
                            </p>
                        </div>
                    </div>

                    {/* //row 2 */}
                    {/* <div
                        className={styles.detailsBoxes}
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'flex-start',
                        }}
                    >
                        <div style={{ minWidth: '200px', margin: '0 10px' }}>
                            <p className="font-bold">Date of Verified</p>
                            <p>25-07-2024</p>
                        </div>
                        <div style={{ minWidth: '200px', margin: '0 10px' }}>
                            <p className="font-bold">Date if Expiration</p>
                            <p>26-04-2024</p>
                        </div>
                        <div style={{ minWidth: '200px', margin: '0 10px' }}>
                            <p></p>
                            <p></p>
                        </div>
                    </div> */}
                </Card>

                <Card
                    sx={{
                        minWidth: 275,
                        margin: '20px',
                        padding: '20px',
                        borderRadius: '10px',
                    }}
                >
                    <div className={styles.profile_information_heading}>
                        <Typography noWrap variant="h5" fontWeight={'bold'}>
                            Verify Certificates{' '}
                        </Typography>
                        {order?.status === 'Pending' && (
                            <Typography
                                noWrap
                                variant="subtitle1"
                                color={'textSecondary'}
                            >
                                (You can only view the file at this stage. Click
                                "Accept" to move it to the In Development stage
                                and begin the verification process)
                            </Typography>
                        )}
                    </div>

                    <div style={{ marginTop: '1rem' }}>
                        <div>
                            {order?.status === 'Completed' && (
                                <div>
                                    <Typography
                                        noWrap
                                        variant="h6"
                                        fontWeight={'bold'}
                                    >
                                        Verification Submitted
                                    </Typography>
                                    <div
                                        style={{
                                            marginTop: '1rem',
                                        }}
                                    >
                                        {order?.verification_order_details &&
                                            order?.verification_order_details.map(
                                                (item) => {
                                                    const detail = order?.requested_for_user.certificates.find(
                                                        (cert) =>
                                                            cert.id ===
                                                            item.user_certificate_id
                                                    );
                                                    const certFileName =
                                                        order?.requested_for_user.certificates.find(
                                                            (cert) =>
                                                                cert.id ===
                                                                item.user_certificate_id
                                                        )?.document

                                                    const attachFileName =
                                                        item.attachment

                                                    const attachFileExt =
                                                        attachFileName
                                                            ? attachFileName
                                                                  .split('.')
                                                                  .pop()
                                                                  .toLowerCase()
                                                            : ''
                                                    const certFileExt =
                                                        certFileName
                                                            ? certFileName
                                                                  .split('.')
                                                                  .pop()
                                                                  .toLowerCase()
                                                            : ''
                                                    //    const FileIcon = getFileIcon(fileExt,order?.status);

                                                    const FileIconAttachment =
                                                        getFileIcon(
                                                            attachFileExt,
                                                            order?.status
                                                        )
                                                    const FileIconCertificate =
                                                        getFileIcon(
                                                            certFileExt,
                                                            order?.status
                                                        )
                                                    return (
                                                        <div
                                                            style={{
                                                                display: 'flex',
                                                                // gap: '1rem',
                                                                alignItems:
                                                                    'center',
                                                            }}
                                                        >
                                                            <div
                                                                style={{
                                                                    display:
                                                                        'flex',
                                                                    // gap: '2rem',
                                                                    marginTop:
                                                                        '1rem',
                                                                    // flexGrow: 1,
                                                                    alignItems:
                                                                        'center',
                                                                }}
                                                            >
                                                                <div
                                                            style={{
                                                                minWidth:
                                                                    '200px',
                                                                margin: '0 10px',
                                                            }}
                                                        >
                                                            <p className="font-bold">
                                                                Title
                                                            </p>
                                                            <p>{detail?.title ? detail?.title:'-'}</p>
                                                        </div>
                                                        <div
                                                            style={{
                                                                minWidth:
                                                                    '100px',
                                                                margin: '0 10px',
                                                            }}
                                                        >
                                                            <p className="font-bold">
                                                                Type
                                                            </p>
                                                            <p>{detail?.type ? detail?.type:'-'}</p>
                                                        </div>
                                                                <div
                                                                    style={{
                                                                        minWidth:
                                                                            '150px',
                                                                        margin: '0 10px',
                                                                    }}
                                                                >
                                                                    <p className="font-bold">
                                                                        Expiry
                                                                        Date
                                                                    </p>
                                                                    <p>
                                                                        {
                                                                            item.expiry_date
                                                                        }
                                                                    </p>
                                                                </div>
                                                                <div
                                                                    style={{
                                                                        minWidth:
                                                                            '100px',
                                                                        margin: '0 10px',
                                                                    }}
                                                                >
                                                                    <p className="font-bold">
                                                                        Status
                                                                    </p>
                                                                    <p>
                                                                        {
                                                                            item.status
                                                                        }
                                                                    </p>
                                                                </div>
                                                                <div
                                                                    style={{
                                                                        minWidth:
                                                                            '200px',
                                                                        margin: '0 10px',
                                                                    }}
                                                                >
                                                                    <p className="font-bold">
                                                                        Comment
                                                                    </p>
                                                                    <p>
                                                                        {!item.comment ||
                                                                        item.comment ==
                                                                            'undefined'
                                                                            ? 'No comments have been made on this certificate.'
                                                                            : item.comment}
                                                                    </p>
                                                                </div>
                                                                <div
                                                                    style={{
                                                                        minWidth:
                                                                            '200px',
                                                                        margin: '0 10px',
                                                                    }}
                                                                >
                                                                    <Link
                                                                        href={
                                                                            order?.requested_for_user.certificates.find(
                                                                                (
                                                                                    cert
                                                                                ) =>
                                                                                    cert.id ===
                                                                                    item.user_certificate_id
                                                                            )
                                                                                ?.ImgURL +
                                                                            order?.requested_for_user.certificates.find(
                                                                                (
                                                                                    cert
                                                                                ) =>
                                                                                    cert.id ===
                                                                                    item.user_certificate_id
                                                                            )
                                                                                ?.document
                                                                        }
                                                                        target="_blank"
                                                                        style={{
                                                                            textDecoration:
                                                                                'none',
                                                                        }}
                                                                    >
                                                                        <Button
                                                                            variant="contained"
                                                                            color="buttonColor"
                                                                            className="active:!bg-[#1167aa] hover:!bg-[#004588]"
                                                                            sx={{
                                                                                display:
                                                                                    'flex',
                                                                                alignItems:
                                                                                    'center',
                                                                                gap: '0.5rem',
                                                                                borderRadius: 10,
                                                                                fontSize:
                                                                                    '12px',
                                                                                minWidth:
                                                                                    '160px',
                                                                                padding:
                                                                                    '13px 20px',
                                                                            }}
                                                                            disableElevation
                                                                            disableRipple
                                                                        >
                                                                            {/* <FaRegFilePdf
                                                                                style={{
                                                                                    fontSize:
                                                                                        '16px',
                                                                                }}
                                                                            /> */}
                                                                            {
                                                                                FileIconCertificate
                                                                            }
                                                                            View
                                                                            Certificate
                                                                        </Button>
                                                                    </Link>
                                                                </div>
                                                                <div
                                                                    style={{
                                                                        minWidth:
                                                                            '200px',
                                                                        margin: '0 10px',
                                                                    }}
                                                                >
                                                                    {!item.attachment ? (
                                                                        <Button
                                                                            disabled={!item.attachment}
                                                                            variant="contained"
                                                                            color="buttonColor"
                                                                            className="active:!bg-[#1167aa] hover:!bg-[#004588]"
                                                                            sx={{
                                                                                display:
                                                                                    'flex',
                                                                                alignItems:
                                                                                    'center',
                                                                                gap: '0.5rem',
                                                                                borderRadius: 10,
                                                                                fontSize:
                                                                                    '12px',
                                                                                minWidth:
                                                                                    '160px',
                                                                                padding:
                                                                                    '13px 20px',
                                                                            }}
                                                                            disableElevation
                                                                            disableRipple
                                                                        >
                                                                            {
                                                                                FileIconAttachment
                                                                            }
                                                                            {!item.attachment
                                                                                ? 'No Attachment'
                                                                                : 'View Attachment'}
                                                                        </Button>
                                                                    ) : (
                                                                        <Link
                                                                            href={
                                                                                item.img_url +
                                                                                item.attachment
                                                                            }
                                                                            target="_blank"
                                                                            style={{
                                                                                textDecoration:
                                                                                    'none',
                                                                            }}
                                                                        >
                                                                            <Button
                                                                                // disabled={!item.attachment}
                                                                                variant="contained"
                                                                                color="buttonColor"
                                                                                className="active:!bg-[#1167aa] hover:!bg-[#004588]"
                                                                                sx={{
                                                                                    display:
                                                                                        'flex',
                                                                                    alignItems:
                                                                                        'center',
                                                                                    gap: '0.5rem',
                                                                                    borderRadius: 10,
                                                                                    fontSize:
                                                                                        '12px',
                                                                                    minWidth:
                                                                                        '160px',
                                                                                    padding:
                                                                                        '13px 20px',
                                                                                }}
                                                                                disableElevation
                                                                                disableRipple
                                                                            >
                                                                                {
                                                                                    FileIconAttachment
                                                                                }
                                                                                
                                                                                    View Attachment
                                                                            </Button>
                                                                        </Link>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            {/* <div>
                                                                <Typography
                                                                    noWrap
                                                                    variant="h6"
                                                                    fontWeight={
                                                                        'bold'
                                                                    }
                                                                >
                                                                    <Link
                                                                        href={
                                                                            order.requested_for_user.certificates.find(
                                                                                (
                                                                                    cert
                                                                                ) =>
                                                                                    cert.id ===
                                                                                    item.user_certificate_id
                                                                            )
                                                                                ?.ImgURL +
                                                                            order.requested_for_user.certificates.find(
                                                                                (
                                                                                    cert
                                                                                ) =>
                                                                                    cert.id ===
                                                                                    item.user_certificate_id
                                                                            )
                                                                                ?.document
                                                                        }
                                                                        target="_blank"
                                                                    >
                                                                        View
                                                                        Certificate
                                                                    </Link>
                                                                </Typography>
                                                            </div> */}
                                                            {/* <div>
                                                                Comment:{' '}
                                                                {!item.comment ||
                                                                item.comment ===
                                                                    undefined
                                                                    ? item.comment
                                                                    : '-'}
                                                            </div>
                                                            <div>
                                                                Status:{' '}
                                                                {item.status}
                                                            </div>
                                                            <div>
                                                                Expiry:{' '}
                                                                {
                                                                    item.expiry_date
                                                                }
                                                            </div> */}
                                                            {/* <div>
                                                                {' '}
                                                                <Typography
                                                                    noWrap
                                                                    variant="h6"
                                                                    fontWeight={
                                                                        'bold'
                                                                    }
                                                                >
                                                                    <Link
                                                                        href={
                                                                            item.img_url +
                                                                            item.attachment
                                                                        }
                                                                        target="_blank"
                                                                    >
                                                                        View
                                                                        Attachment
                                                                    </Link>
                                                                </Typography>
                                                            </div> */}
                                                        </div>
                                                    )
                                                }
                                            )}
                                    </div>
                                </div>
                            )}

                            {order?.status === 'Pending' &&
                                order?.requested_for_user.certificates &&
                                order?.requested_for_user.certificates.filter((f) => f.status !== 'Verified').map(
                                    (item, index) => {
                                        const fileName = item.document
                                        const fileExt = fileName
                                            ? fileName
                                                  .split('.')
                                                  .pop()
                                                  .toLowerCase()
                                            : ''

                                        const FileIcon = getFileIcon(
                                            fileExt,
                                            order?.status
                                        )
                                        return (
                                            <div
                                                key={item.id}
                                                style={{
                                                    minWidth: 275,
                                                    margin: '20px',
                                                    padding: '20px',
                                                    borderRadius: '5px',
                                                    borderColor: '#f1f5f9',
                                                    borderStyle: 'solid',
                                                }}
                                            >
                                                <div>
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            gap: '2rem',
                                                            marginTop: '1rem',
                                                            // flexGrow: 1,
                                                            alignItems:
                                                                'center',
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                minWidth:
                                                                    '200px',
                                                                margin: '0 10px',
                                                            }}
                                                        >
                                                            <p className="font-bold">
                                                                Title
                                                            </p>
                                                            <p>{item.title}</p>
                                                        </div>
                                                        <div
                                                            style={{
                                                                minWidth:
                                                                    '100px',
                                                                margin: '0 10px',
                                                            }}
                                                        >
                                                            <p className="font-bold">
                                                                Type
                                                            </p>
                                                            <p>{item.type}</p>
                                                        </div>
                                                        <div
                                                            style={{
                                                                minWidth:
                                                                    '100px',
                                                                margin: '0 10px',
                                                            }}
                                                        >
                                                            <p className="font-bold">
                                                                Expiry Date
                                                            </p>
                                                            <p>{item.expiry}</p>
                                                        </div>
                                                        <div
                                                            style={{
                                                                minWidth:
                                                                    '100px',
                                                                margin: '0 10px',
                                                            }}
                                                        >
                                                            <p className="font-bold">
                                                                Status
                                                            </p>
                                                            <p>{item.status}</p>
                                                        </div>
                                                        <div
                                                            style={{
                                                                minWidth:
                                                                    '200px',
                                                                margin: '0 10px',
                                                            }}
                                                        >
                                                            <p className="font-bold">
                                                                Certificate Name
                                                            </p>
                                                            <div
                                                                style={{
                                                                    display:
                                                                        'flex',
                                                                    alignItems:
                                                                        'center',
                                                                    gap: '0.5rem',
                                                                }}
                                                            >
                                                                {FileIcon}
                                                                <span>
                                                                    {fileName}
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div
                                                            style={{
                                                                minWidth:
                                                                    '200px',
                                                                margin: '0 10px',
                                                            }}
                                                        >
                                                            <Link
                                                                href={
                                                                    item.ImgURL +
                                                                    item.document
                                                                }
                                                                target="_blank"
                                                                style={{
                                                                    textDecoration:
                                                                        'none',
                                                                }}
                                                            >
                                                                <Button
                                                                    variant="contained"
                                                                    color="buttonColor"
                                                                    className="active:!bg-[#1167aa] hover:!bg-[#004588]"
                                                                    sx={{
                                                                        display:
                                                                            'flex',
                                                                        alignItems:
                                                                            'center',
                                                                        gap: '0.5rem',
                                                                        borderRadius: 10,
                                                                        fontSize:
                                                                            '12px',
                                                                        minWidth:
                                                                            '160px',
                                                                        padding:
                                                                            '13px 20px',
                                                                    }}
                                                                    disableElevation
                                                                    disableRipple
                                                                >
                                                                    <FaRegFilePdf
                                                                        style={{
                                                                            fontSize:
                                                                                '16px',
                                                                        }}
                                                                    />
                                                                    View
                                                                    Certificate
                                                                </Button>
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    }
                                )}

                            {/* {order.status !== 'Completed' && */}
                            {order?.status === 'Accepted' &&
                                certificateFields &&
                                certificateFields.map((item, index) => {
                                    return (
                                        <div
                                            key={item.id}
                                            style={{
                                                minWidth: 275,
                                                margin: '20px',
                                                padding: '20px',
                                                borderRadius: '5px',
                                                borderColor: '#f1f5f9',
                                                borderStyle: 'solid',
                                            }}
                                        >
                                            <div>
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        gap: '2rem',
                                                        marginTop: '1rem',
                                                        // flexGrow: 1,
                                                        alignItems: 'center',
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            gap: '3.5rem',
                                                            alignItems:
                                                                'center',
                                                            flexGrow: 3,
                                                        }}
                                                    >
                                                        <span>Expiry</span>
                                                        {/* <InputBox
                                                            name={`certificates[${index}].certificate_expiry`}
                                                            type="date"
                                                            control={control}
                                                            style={{
                                                                flex: '1',
                                                            }}
                                                            readOnly
                                                        /> */}
                                                        <div className="border border-[#C4C4C4] hover:border-black hover:cursor-text flex-1 p-[1.15rem] !rounded-[4px]">
                                                            {
                                                                item.certificate_expiry
                                                            }
                                                        </div>
                                                    </div>

                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            gap: '1rem',
                                                            flexGrow: 4.5,
                                                            alignItems:
                                                                'center',
                                                        }}
                                                    >
                                                        <span>Status</span>
                                                        <DropDownCmp
                                                            name={`certificates[${index}].certificate_status`}
                                                            options={[
                                                                'Verified',
                                                                'Not Verified',
                                                                'Expired',
                                                            ]}
                                                            control={control}
                                                            style={{
                                                                flex: '1',
                                                            }}
                                                            disableClearable
                                                            freeSolo={false}
                                                            disabled={
                                                                order.status !==
                                                                'Accepted'
                                                            }
                                                        />
                                                    </div>
                                                </div>

                                                <div>
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            gap: '1rem',
                                                            flexGrow: 1,
                                                            alignItems:
                                                                'center',
                                                        }}
                                                    >
                                                        <Controller
                                                            disabled={
                                                                order.status !==
                                                                'Accepted'
                                                            }
                                                            name={`certificates[${index}].certificate_attachment`}
                                                            control={control}
                                                            defaultValue=""
                                                            render={({
                                                                field,
                                                            }) => (
                                                                <input
                                                                    accept="/*"
                                                                    disabled={
                                                                        order.status !==
                                                                        'Accepted'
                                                                    }
                                                                    style={{
                                                                        display:
                                                                            'none',
                                                                    }}
                                                                    id={`certificates-${index}-certificate_attachment_upload`}
                                                                    type="file"
                                                                    onChange={(
                                                                        e
                                                                    ) => {
                                                                        const file =
                                                                            e
                                                                                .target
                                                                                .files[0]

                                                                        setValue(
                                                                            `certificates[${index}].certificate_attachment_name`,
                                                                            file.name
                                                                        )
                                                                        setValue(
                                                                            `certificates[${index}].certificate_attachment`,
                                                                            file
                                                                        )
                                                                    }}
                                                                />
                                                            )}
                                                        />
                                                        {/* <Controller
                                                            name={`certificates[${index}].certificate_attachment`}
                                                            control={control}
                                                            defaultValue={[]}
                                                            render={({
                                                                field,
                                                            }) => (
                                                                <>
                                                                    <input
                                                                        accept=".jpg,.png,.jpeg,.pdf,.doc,.docx"
                                                                        multiple
                                                                        style={{
                                                                            display:
                                                                                'none',
                                                                        }}
                                                                        id={`certificates-${index}-certificate_attachment_upload`}
                                                                        type="file"
                                                                       
                                                                        onChange={(
                                                                            e
                                                                        ) => {
                                                                            const files =
                                                                                Array.from(
                                                                                    e
                                                                                        .target
                                                                                        .files
                                                                                )

                                                                            setValue(
                                                                                `certificates[${index}].certificate_attachment`,
                                                                                files
                                                                            )
                                                                            setValue(
                                                                                `certificates[${index}].certificate_attachment_name`,
                                                                                files.map(
                                                                                    (
                                                                                        f
                                                                                    ) =>
                                                                                        f.name
                                                                                )
                                                                            )
                                                                        }}
                                                                    />
                                                                </>
                                                            )}
                                                        /> */}
                                                    </div>
                                                </div>

                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        gap: '2rem',
                                                        marginTop: '1rem',
                                                        marginBottom: '2rem',
                                                        alignItems: 'center',
                                                    }}
                                                >
                                                    <span>Comment</span>
                                                    <TextAreaCmp
                                                        name={`certificates[${index}].certificate_comment`}
                                                        type="text"
                                                        control={control}
                                                        style={{ flex: '1' }}
                                                        disabled={
                                                            order.status !==
                                                            'Accepted'
                                                        }
                                                    />
                                                </div>

                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        gap: '1rem',
                                                    }}
                                                >
                                                    <div className="flex-grow">
                                                        {/* {watch(
                                                            `certificates[${index}].certificate_attachment_name`
                                                        ) && (
                                                            <div className="w-fit p-3 rounded-md bg-slate-200">
                                                                {watch(
                                                                    `certificates[${index}].certificate_attachment_name`
                                                                )}
                                                            </div>
                                                        )} */}
                                                        {watch(
                                                            `certificates[${index}].certificate_attachment_name`
                                                        ) && (
                                                            <div className="w-fit p-3 rounded-md bg-slate-200 flex gap-2 items-center">
                                                                {/* <div className="w-fit p-3 rounded-md flex gap-2 items-center"> */}
                                                                <span>
                                                                    {watch(
                                                                        `certificates[${index}].certificate_attachment_name`
                                                                    )}
                                                                </span>
                                                                <button
                                                                    type="button"
                                                                    onClick={() => {
                                                                        setValue(
                                                                            `certificates[${index}].certificate_attachment`,
                                                                            []
                                                                        )
                                                                        setValue(
                                                                            `certificates[${index}].certificate_attachment_name`,
                                                                            ''
                                                                        )
                                                                    }}
                                                                    className="text-red-600 hover:underline"
                                                                >
                                                                    X
                                                                </button>
                                                                {/* {watch(
                                                                    `certificates[${index}].certificate_attachment_name`
                                                                )?.map(
                                                                    (
                                                                        name,
                                                                        i
                                                                    ) => (
                                                                        <div
                                                                            key={
                                                                                i
                                                                            }
                                                                            className="w-fit p-3 rounded-md bg-slate-200 flex gap-2 items-center"
                                                                        >
                                                                            <span>
                                                                                {
                                                                                    name
                                                                                }
                                                                            </span>
                                                                            <button
                                                                                type="button"
                                                                                onClick={() => {
                                                                                    const newFiles =
                                                                                        watch(
                                                                                            `certificates[${index}].certificate_attachment`
                                                                                        ).filter(
                                                                                            (
                                                                                                _,
                                                                                                j
                                                                                            ) =>
                                                                                                j !==
                                                                                                i
                                                                                        )
                                                                                    const newNames =
                                                                                        watch(
                                                                                            `certificates[${index}].certificate_attachment_name`
                                                                                        ).filter(
                                                                                            (
                                                                                                _,
                                                                                                j
                                                                                            ) =>
                                                                                                j !==
                                                                                                i
                                                                                        )

                                                                                    setValue(
                                                                                        `certificates[${index}].certificate_attachment`,
                                                                                        newFiles
                                                                                    )
                                                                                    setValue(
                                                                                        `certificates[${index}].certificate_attachment_name`,
                                                                                        newNames
                                                                                    )
                                                                                }}
                                                                                className="text-red-600 hover:underline"
                                                                            >
                                                                                X
                                                                            </button>
                                                                        </div>
                                                                    )
                                                                )} */}
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div>
                                                        <Link
                                                            href={
                                                                item.certificate_attachment_url
                                                            }
                                                            target="_blank"
                                                            style={{
                                                                textDecoration:
                                                                    'none',
                                                            }}
                                                        >
                                                            <Button
                                                                variant="contained"
                                                                color="buttonColor"
                                                                className="active:!bg-[#1167aa] hover:!bg-[#004588]"
                                                                sx={{
                                                                    display:
                                                                        'flex',
                                                                    alignItems:
                                                                        'center',
                                                                    gap: '0.5rem',
                                                                    borderRadius: 10,
                                                                    fontSize:
                                                                        '12px',
                                                                    minWidth:
                                                                        '160px',
                                                                    padding:
                                                                        '13px 20px',
                                                                }}
                                                                disableElevation
                                                                disableRipple
                                                            >
                                                                <FaRegFilePdf
                                                                    style={{
                                                                        fontSize:
                                                                            '16px',
                                                                    }}
                                                                />
                                                                View Certificate
                                                            </Button>
                                                        </Link>
                                                    </div>
                                                    <div>
                                                        <div>
                                                            <label
                                                                htmlFor={`certificates-${index}-certificate_attachment_upload`}
                                                                className="!flex items-center !bg-[#005699] active:!bg-[#1167aa] hover:!bg-[#004588] text-white justify-center uppercase !rounded-full !cursor-pointer"
                                                                style={{
                                                                    gap: '0.5rem',
                                                                    borderRadius: 10,
                                                                    fontSize:
                                                                        '12px',
                                                                    minWidth:
                                                                        '160px',
                                                                    padding:
                                                                        '14px 20px',
                                                                }}
                                                            >
                                                                <IoMdAttach
                                                                    style={{
                                                                        fontSize:
                                                                            '16px',
                                                                    }}
                                                                />
                                                                Attach File
                                                            </label>
                                                        </div>
                                                        <div
                                                            style={{
                                                                fontSize:
                                                                    '10px',
                                                                color: 'red',
                                                                marginTop:
                                                                    '10px',
                                                            }}
                                                        >
                                                            {' '}
                                                            {!watch(
                                                                `certificates[${index}].certificate_attachment_name`
                                                            ) && errors[index]
                                                                ? errors[index]
                                                                      ?.certificate_attachment
                                                                      .message
                                                                : ''}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                            {order?.status !== 'Accepted' ||
                                (dayDifference <= 800 && (
                                    <div
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'end',
                                            marginRight: '1rem',
                                        }}
                                    >
                                        <ButtonCmp
                                            title={
                                                submitting
                                                    ? 'Submitting...'
                                                    : 'Submit'
                                            }
                                            // onClick={() => {
                                            //     handleSubmit(
                                            //         onSubmit,
                                            //         (errors) => {
                                            //             setErrors(
                                            //                 errors.certificates
                                            //             )
                                            //         }
                                            //     )()
                                            // }}
                                            onClick={() => {
                                                handleSubmit(onSubmit)()
                                            }}
                                            disabled={
                                                order.status !== 'Accepted' ||
                                                submitting
                                            }
                                        ></ButtonCmp>
                                    </div>
                                ))}
                        </div>
                    </div>
                </Card>
            </Box>
        </>
    )
}

export default Detail
